import * as React from "react";
import {
  Card as MuiCard,
  Button,
  Typography,
  Box,
  InputBase,
  Card,
  CardContent,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import { Search } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { usePrivileges } from "../../util/usePrivileges";
import HelpSupportIcon from "../Icons/HelpSupportIcon";
import RightCarretIcon from "../Icons/RightCarretIcon";
import SubscribePostScreen from "./index";

function ChannelList() {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = React.useState("");
  const [subscribeScreen, setSubscribeScreen] = React.useState({});
  const { singleProgram } = useSelector((state: RootState) => state.programReducer);
  const { privileges } = usePrivileges();

  const communityList = singleProgram?.communities || [];
  const allChannels = communityList.flatMap((community) =>
    (community.channels || []).map((channel: any) => ({
      ...channel,
      communityIdentifier: community.communityIdentifier,
    }))
  );

  const uniqueIds = new Set<string>();
  const uniqueChannels = allChannels.filter((item: any) => {
    const key = `${item.communityIdentifier || ''}::${item.channelIdentifier || item.channelName}`;
    if (uniqueIds.has(key)) return false;
    uniqueIds.add(key);
    return true;
  });

  const viewableChannels = uniqueChannels.filter((channel: any) => {
    const communityId = channel?.communityIdentifier || '';
    const channelId = channel?.channelIdentifier || '';
    if (!channelId) return false;
    return privileges.canViewChannel(communityId, channelId);
  });

  const filteredChannels = viewableChannels.filter((post: any) =>
    post?.channelName?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const visitChannel = (data) => {
    setSubscribeScreen(data);
  };
  const handleBack = () => {
    setSubscribeScreen({});
  };

  return (
    <>
      {Object.keys(subscribeScreen).length > 0 ? (
        <SubscribePostScreen
          channel={subscribeScreen}
          handleBack={handleBack}
        />
      ) : (
        <div className={classes.container}>
          <MuiCard className={classes.card}>
            <Box className={classes.header}>
              <Link to="/admin/channel">
                <img src={backIcon} alt="Back" className={classes.backIcon} />
              </Link>
              <Box className={classes.logoWrapper}>
              <img src={logo} alt="Logo" className={classes.logo} />
              </Box>

            </Box>

            <Typography
              variant="h3"
              className={classes.mainTitle}
              style={{ fontSize: "30px" }}
            >
              Channel list
            </Typography>
            <Typography variant="h5" className={classes.communityHeading}>
              Search channel and subscribe
            </Typography>
            <div className={classes.searchInput}>
              <InputBase
                placeholder="Search"
                fullWidth
                onChange={(e) => setSearchQuery(e.target.value)}
                startAdornment={
                  <Search style={{ marginRight: 8, cursor: "pointer" }} />
                }
              />
            </div>
            {filteredChannels?.map((post: any) => (
              <Card className={classes.channelListCard}>
                <div className={classes.subscribeFlag}>
                  <HelpSupportIcon width={40} height={40} />
                </div>
                <div className={classes.channelCardDetails}>
                  <CardContent className={classes.content}>
                    <Typography
                      variant="h5"
                      className={classes.communityHeading}
                    >
                      {post.channelName}
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      style={{ color: "#000000" }}
                    >
                      Protecting Communities, Ensuring Safetys
                    </Typography>
                    <Button
                      className={classes.channelListingButton}
                      onClick={() => {
                        visitChannel(post);
                      }}
                    >
                      Go to Channel
                      <RightCarretIcon width={30} height={30} />
                    </Button>
                  </CardContent>
                </div>
              </Card>
            ))}
          </MuiCard>
        </div>
      )}
    </>
  );
}

export default ChannelList;
